import { resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65f9d3f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-auto flex w-full justify-center" }
const _hoisted_2 = { class: "relative h-[512px] w-full bg-[#1D232D]" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "px-7 pt-[25px] pb-[42px]" }
const _hoisted_5 = { class: "mb-[18px] flex justify-between" }
const _hoisted_6 = { class: "mb-[7px] text-left text-[18px] font-bold leading-[136%] tracking-[-0.015em]" }
const _hoisted_7 = { class: "text-left text-[14px] font-normal leading-[136%] text-[#ADADAD]" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-[14px] font-bold leading-[136%] tracking-[-0.015em] text-white" }, " 영상 다운로드 ", -1))
const _hoisted_11 = { class: "text-[14px] font-normal leading-[136%] tracking-[-0.015em] text-[#8390A5]" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Video = _resolveComponent("Video")!
  const _component_DefaultContainer = _resolveComponent("DefaultContainer")!

  return (_openBlock(), _createBlock(_component_DefaultContainer, {
    class: "fixed left-0 top-0 z-50 flex h-full min-w-0 overflow-scroll bg-[rgba(0,0,0,0.4)] backdrop-blur transition-all",
    onClick: _cache[4] || (_cache[4] = () => _ctx.$emit('update:modelValue', false))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "relative my-12 w-[910px] overflow-hidden rounded-[30px] bg-white transition-all",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_Transition, { name: "fadein" }, {
              default: _withCtx(() => [
                _createVNode(_component_Video, {
                  ref: "video",
                  controls: _ctx.isPlayed,
                  src: _ctx.props.value?.url,
                  class: "relative h-full w-full",
                  playsinline: "",
                  disablePictureInPicture: "",
                  controlslist: "nodownload",
                  onCanplay: _cache[0] || (_cache[0] = () => (_ctx.canPlay = true))
                }, null, 8, ["controls", "src"])
              ]),
              _: 1
            }),
            _createVNode(_Transition, { name: "fadeout" }, {
              default: _withCtx(() => [
                (!_ctx.isPlayed)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "absolute top-0 flex h-full w-full cursor-pointer items-center justify-center bg-[rgba(0,0,0,0.25)] transition-all",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handlePlay && _ctx.handlePlay(...args)))
                    }, [
                      _createElementVNode("img", {
                        src: require('@assets/icons/PlayButton.svg'),
                        alt: "play button"
                      }, null, 8, _hoisted_3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.props.value?.title), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.convertNumberToTimestamp(_ctx.props.value?.created as number)), 1)
              ]),
              _createElementVNode("a", {
                href: _ctx.props.value?.url,
                download: "",
                target: "_blank",
                class: "flex h-9 items-center rounded-[5px] bg-[#4535D8] pl-[13px] pr-4"
              }, [
                _createElementVNode("img", {
                  src: require('@assets/icons/Download.svg'),
                  class: "mr-[5px]"
                }, null, 8, _hoisted_9),
                _hoisted_10
              ], 8, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.props.value?.text), 1)
          ]),
          _createElementVNode("img", {
            src: require('@assets/icons/CloseButton.svg'),
            alt: "close button",
            class: "absolute right-[38px] top-[38px] cursor-pointer",
            onClick: _cache[2] || (_cache[2] = () => _ctx.$emit('update:modelValue', false))
          }, null, 8, _hoisted_12)
        ])
      ])
    ]),
    _: 1
  }))
}